import { Grid2, TextField, Box, Paper, Typography, IconButton, Icon } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { StandardButton } from "../../../_components/button/primary.button";
import { StandardPanel } from "../../../_components/panel/standard.panel";
import { toastr } from "../../../_components/toastr/toastr";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { FileTypeEnum } from "../../../_common/enum";
import { fileUploadService } from "../../../_services/fileUpload.service";
import { StandardTablePanel } from "../../../_components/panel/standardTable.panel";
import { MRT_ColumnDef } from "material-react-table";
import { filter } from "rxjs";
import { TABLE_FILTER } from "../../../_const/tableFilter.const";
import { FileStateEnum } from "../../../_common/enum/fileUploadState.enum";
import { getDateString } from "../../../_helpers/dateTime.helper";
import { StandardTable } from "../../../_components/table/standard.table";
import { CentreDetailsManageDrawer } from "./centre-detailsManageDrawer";
import { CentreFileManageDrawer } from "./centre-filePanelManageDrawer";



export const CentreFileUploadPanel = () => {

    const { centreId } = useParams<{ centreId: string }>();
    const [isLoading, setIsLoading] = useState(false);
    const [filter, setFilter] = useState<any>({ ...TABLE_FILTER, pageSize: "10", orderBy: "" });
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const navigate = useNavigate();

    useEffect(() => {
        if (centreId != null) fetchData();
    }, [centreId]);


    function fetchData() {
        if (!centreId) return;
        setIsLoading(true);
        return fileUploadService.getAll(FileTypeEnum.CentreFile, centreId)
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    }


    function download(id: string) {
        return fileUploadService.download(id, FileTypeEnum.CentreFile);
    }


    function disable(id: string) {
        if (!id) return;
        setIsLoading(true);

        return fileUploadService
            .disable(id)
            .then(
                () => {
                    toastr.success("File deleted successfully");
                    fetchData();
                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: '',
                size: 1,
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
                Cell: ({ row }) => (<>
                    <IconButton
                        color="primary" sx={{ mr: 2 }}
                        onClick={() => { download(row.original.fileUploadId) }}>
                        <Icon>download</Icon>
                    </IconButton>
                    <IconButton
                        color="primary"
                        onClick={() => { disable(row.original.fileUploadId) }}>
                        <Icon>delete</Icon>
                    </IconButton>
                </>
                ),
            },
            {
                size: 2,
                accessorKey: 'fileName',
                header: 'File Name',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
            },
            {
                size: 2,
                accessorKey: 'uploadedBy',
                header: 'Uploaded By',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,

            },
            {
                size: 2,
                accessorKey: 'uploadedDate',
                header: 'Uploaded On',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
                Cell: ({ row }) => (
                    <>{!!row.original.uploadedDate ? getDateString(row.original.uploadedDate) : ""}</>
                ),
            },
            {
                accessorKey: 'state',
                header: 'Status',
                size: 2,
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
                accessorFn: (rowData: any) => <>
                    {rowData.state !== null ? FileStateEnum[rowData.state] : ""}
                </>
            },

        ],
        []
    );

    return (
        <>
            <StandardPanel
                title="Files"
                buttons={[
                    { icon: "add", onClick: () => { navigate("ManageFileUpload/") } },
                ]} loading={isLoading}>


                <StandardTable columns={columns}
                    data={data}
                    filter={filter}
                    setFilter={setFilter}
                    loading={isLoading}></StandardTable>
            </StandardPanel>



            <Routes>
                <Route path="ManageFileUpload/" element={<CentreFileManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate(""); fetchData(); }} />} />
            </Routes>
        </>
    );
};

